'use client';

import Image from '@eliadmin/core/src/components/image/image-wrapped';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Heading } from '../ui/heading';
import { Paragraph } from '../ui/paragraph';
import { PartnerButton } from './partner-button';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export function PartnerBanner({ className, id }: { className?: string; id?: string }) {
  const { t } = useTranslations();

  return (
    <section id={id} className={cn('custom-section', className)}>
      <div
        className={cn(
          'custom-container',
          'relative z-10 flex flex-col items-center justify-center overflow-hidden rounded-[16px] bg-[#F2EDE6] p-6 sm:p-7 md:flex-row md:items-center md:justify-between lg:p-8',
        )}
      >
        <div className="relative z-[10] flex w-full max-w-[734px] flex-col items-start justify-start gap-8">
          <div className="flex w-full flex-col items-start justify-start gap-4">
            <Heading
              title={'<span>Chcete implementovať</span><br/>HASQO vo vašej prevádzke?'}
              className={{ vector: '-bottom-3' }}
            />
            <Paragraph>{t('text3544')}</Paragraph>
          </div>
          <PartnerButton />
        </div>
        <Image
          src={'/images/form-overlay.png'}
          alt="Banner"
          width={0}
          height={0}
          className="absolute inset-0 z-0 h-full w-full object-cover object-center opacity-15 mix-blend-darken"
          sizes="100vw"
        />
      </div>
    </section>
  );
}
